import request from "@/router/axios"
export const all = () => {
    return request({
        url: `/api/op/dept/list`,
        method: 'post',
        data: {
            filterParams: [{ name: "isValid", value: true }],
            orderBy: "id",
            isDesc: false
        }
    })
}
export const getHosDepts = () => {
    return request({
        url: `/api/op/dept/getHosDepts`,
        method: 'get',
    })
}
export const getUserHosDepts = () => {
    return request({
        url: `/api/op/dept/getUserHosDepts`,
        method: 'get',
    })
}
export const getAuthDepts = () => {
    return request({
        url: `/api/op/dept/getAuthDepts`,
        method: 'get',
    })
}
export const editDept = (data) => {
    return request({
        url: `/api/op/dept/edit`,
        method: 'post',
        data: data
    })
}
export const saveDept = (data) => {
    return request({
        url: `/api/op/dept/saveDept`,
        method: 'post',
        data: data
    })
}
